import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';

import { GUEST_USER_STATE_IN_PROGRESS } from '../../components/SocialButtons/Share/InternalShare/constants/share';

import { gqlRequest } from '../../helpers/request';
import { addMockInvitationsAction, sendInvitationAction } from '../slices/guestShare';

const queryGQL = `
  mutation hostedWatchSendInvitation(
    $emails: [String],
    $videoId: String,
    $url: String,
    $message: String,
  ) {
    hostedWatchSendInvitation(
      emails: $emails,
      videoId: $videoId,
      url: $url,
      message: $message,
    )
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(sendInvitationAction.type),
    switchMap(({ payload }) =>
      gqlRequest({
        query: queryGQL,
        variables: payload,
      }).pipe(
        map(() => {
          const mockInvitations = payload.emails.map((email) => ({
            invitationId: `mock-${email}`,
            email,
            state: GUEST_USER_STATE_IN_PROGRESS,
          }));

          return addMockInvitationsAction(mockInvitations);
        }),
      ),
    ),
  );
